<template>
  <v-text-field
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.floor, 'Etaj')"
      v-model="floor"
      :rules="floorValidationRules"
      name="floor"
      variant="outlined"
      bg-color="surface"
      :tile="true"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
  },
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const floor = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      floor.value = newValue;
    });

    watch(floor, (newValue) => {
      const isValid = validateFloor(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', null);
      }
      emit('validation-address-status', { field: 'floor', isValid });
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const floorValidationRules = [
      (v: string) => /^[A-Za-z0-9\s]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateFloor(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = floorValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return floorValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateFloor(floor.value);
      emit('validation-address-status', { field: 'floor', isValid });

      // Listen for validate events
      window.addEventListener('validate-address', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === 'floor') {
        const isValid = validateFloor(floor.value, true);
        if (isValid) {
          emit('validation-address-status', { field: 'floor', isValid });
        }
      }
    };

    return {
      floor,
      floorValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>